<template>
  <div id="employee-detail">
    <CRow>
      <CCol :md="{ size: 8, offset: 2 }" class="employees-form">
        <div class="text-center">
          <h4 class="title-header">
            {{ $t("label.label_sabbatical_leave_infomation") }}
          </h4>
        </div>
        <div class="text-content">
          <label>{{ $t("employee.label_employee_code") }}</label>
          <div class="show-text">
            {{ sabbaticalCompensateDetail.employee_id }}
          </div>
        </div>

        <div class="text-content">
          <label>{{ $t("employee.label_employee_name") }}</label>
          <div class="show-text">
            {{
              sabbaticalCompensateDetail.employee_name
                ? sabbaticalCompensateDetail.employee_name
                : ""
            }}
          </div>
        </div>

        <div class="text-content">
          <label>{{ $t("employee.label_employee_foot") }}</label>
          <div class="show-text">
            {{ sabbaticalCompensateDetail.foot_code }}
          </div>
        </div>

        <div class="text-content">
          <label>{{ $t("employee.label_employee_division") }}</label>
          <div class="show-text">
            {{ sabbaticalCompensateDetail.department_code }}
          </div>
        </div>

        <div class="text-content">
          <label>{{ $t("commons.time_compensate") }}</label>
          <div class="show-text">
            {{ sabbaticalCompensateDetail.time_compensate }}
          </div>
        </div>

        <div class="text-content">
          <label>{{ $t("employee.label_employee_workday_actual") }}</label>
          <div class="show-text">
            {{ sabbaticalCompensateDetail.workday_actual }}
          </div>
        </div>

        <div class="text-content">
          <label>{{ $t("employee.label_employee_workday_payroll") }}</label>
          <div class="show-text">
            {{ sabbaticalCompensateDetail.workday_payroll }}
          </div>
        </div>

        <div class="text-content">
          <label>{{ $t("employee.label_number_of_day_compensate") }}</label>
          <div class="show-text">
            {{ sabbaticalCompensateDetail.number_of_day_compensate }}
          </div>
        </div>

        <div class="text-content">
          <label>{{ $t("employee.label_workday_after_compensate") }}</label>
          <div class="show-text">
            {{ sabbaticalCompensateDetail.workday_after_compensate }}
          </div>
        </div>
        <div class="text-content">
          <label>{{ $t("employee.label_employee_note") }}</label>
          <div class="show-text">
            {{ sabbaticalCompensateDetail.note }}
          </div>
        </div>
        <div class="text-content">
          <label>{{ $t("commons.label_status") }}</label>
          <div class="show-text">
            {{
              $t(
                `commons.label_status_sabbatical_leave_request_${sabbaticalCompensateDetail.status}`
              )
            }}
          </div>
        </div>
      </CCol>
    </CRow>
    <CRow>
      <CCol md="8" sm="12" class="employees-form approval-ot">
        <div class="text-label">
          <div class="text-center">
            <h4 class="title-header">
              {{ $t("overtime.information_approval_ot") }}
            </h4>
          </div>
        </div>
        <div class="text-label-content">
          <div class="table-responsive table-employee-note">
            <table class="table">
              <thead>
                <tr>
                  <th class="index">#</th>
                  <th class="text-center create-by">
                    {{ $t("overtime.employee_approval") }}
                  </th>
                  <th class="text-center create-at">
                    {{ $t("overtime.employee_approval_status") }}
                  </th>
                  <th class="text-center">
                    {{ $t("overtime.employee_approval_note") }}
                  </th>
                  <th class="text-center">
                    {{ $t("overtime.employee_approval_time") }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item,
                  index) in sabbaticalCompensateDetail.monthly_work_time_additional_approve"
                  :key="index"
                >
                  <th scope="row index">{{ index + 1 }}</th>
                  <td>{{ item.approve_by }}</td>
                  <td class="text-center create-at">
                    {{ $t(`overtime.employee_approval_${item.status}`) }}
                  </td>
                  <td class="text-center comment">{{ item.comment }}</td>
                  <td class="text-center">
                    {{ formatDate(item.updated_at) }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </CCol>
    </CRow>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
export default {
  name: "Detail",
  metaInfo() {
    return {
      title: this.$t("page_title.page_sabbatical_compensate_detail"),
      titleTemplate: "%s | " + this.$t("page_title.head_title")
    };
  },
  data() {
    return {};
  },
  created() {
    this.showSabbaticalCompensateRequest();
  },

  computed: {
    ...mapGetters({
      sabbaticalCompensateDetail:
        "sabbatical-compensate/sabbaticalCompensateDetail"
    })
  },

  methods: {
    ...mapActions({
      detailSabbaticalCompensateRequest:
        "sabbatical-compensate/detailSabbaticalCompensateRequest"
    }),
    async showSabbaticalCompensateRequest() {
      let sabbaticalCompensateRequestId = this.$route.params.id;
      await this.detailSabbaticalCompensateRequest(
        sabbaticalCompensateRequestId
      );
    },

    objectNotNull(obj) {
      if (obj) {
        return Object.keys(obj).length !== 0;
      }
    },
    formatDate(value) {
      if (value) {
        return moment(String(value)).format("DD/MM/YYYY HH:mm:ss");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
#employee-detail {
  padding: 20px 100px;
  .title-header {
    margin-bottom: 47px;
    border-bottom: 2px solid #ea8910;
    padding-bottom: 15px;
    text-transform: uppercase;
    font-weight: 600;
    font-size: 16px;
  }
  .employees-form {
    padding: 0 50px;
    margin-bottom: 30px;
    .text-label h4 {
      color: #333;
      font-weight: 600;
      font-size: 20px;
      margin-bottom: 30px;
      .icon-text-label {
        margin-left: 8px;
      }
    }
    .text-content {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 10px;
      .image {
        width: 70%;
      }
      label {
        width: 30%;
        color: #333;
        font-size: 13px;
        font-weight: 600;
      }
    }
    .show-text {
      border: 1px solid #fff;
      background-color: #fff;
      border: 1px solid #ccc;
      width: 70%;
      padding: 0 10px;
      height: 25px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .text-area {
      height: 60px;
    }
    .required {
      color: #dc1313;
      font-size: 13px;
    }
  }
  #toggle-btn {
    height: 37px;
  }
  .employees-form.approval-ot {
    margin: auto;

    .table-employee-note {
      background-color: white;
      margin-top: 20px;

      th {
        font-size: 15px;
      }

      td {
        color: #3c4b64;
      }

      td.comment {
        max-width: 300px;
        word-wrap: break-word;
      }
    }
  }
}
</style>
